// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import logo from "./img/Logo (1).png";
// import { library } from '@fortawesome/fontawesome-svg-core';
// import { fas } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import Table from './orderPaymentAprroverTable';
// import CampaignForm from "./CampaignCreateForm";
// import Live from './live';
// import Modal from '../pages/invite';
// import UserTable from '../pages/userTable';
// import MasterTable from '../pages/masterTable';
// import MenuItem from './MenuItem'; // Ensure you have a MenuItem component
// import AllUser from './allCampaingsApplied'

// library.add(fas);

// const AdminDashboard = () => {
//     const [activeSection, setActiveSection] = useState("allCampaigns");
//     const [isActive, setIsActive] = useState(false);
//     const navigate = useNavigate();
//     const location = useLocation();
//     const brandName = location.state ? location.state.brandName : null;

//     const handleMouseEnter = () => setIsActive(true);
//     const handleMouseLeave = () => setIsActive(false);

//     const handleLogout = () => {
//         localStorage.removeItem("userToken");
//         navigate('/signin', { replace: true });
//     };
//     return (
//         <div className="dashboard">
//             <nav className="navbar" role="navigation" aria-label="main navigation">
//                 <div className="navbar-brand">
//                     <a className="navbar-item"></a>
//                 </div>

//                 <div>
//                     <span className="icon mr-3">
//                         <img src="./images/hobo.jpeg" alt="Menu Icon" style={{ marginRight: "30px" }} />
//                     </span>

//                     <div className={`navbar-menu ${isActive ? 'is-active' : ''}`} style={{ backgroundColor: 'dark-blue' }}>
//                         <aside
//                             className={`menu ${isActive ? '' : 'is-hidden'} overflow-hidden`}
//                             onMouseEnter={handleMouseEnter}
//                             onMouseLeave={handleMouseLeave}
//                         >
//                             <ul className="d-flex flex-row-reverse">
//                                 <div className='has-text-left ml-5'>
//                                     <figure className="image is-32x32">
//                                         <img src={logo} alt="Logo" />
//                                     </figure>

//                                     <li className='my-5 has-text-white' onClick={() => setActiveSection("createCampaign")}>
//                                         <MenuItem title="Create New Campaign" icon="fas fa-plus" />
//                                     </li>
//                                     <li className='my-5 has-text-white' onClick={() => setActiveSection("shortlistedInfluencers")}>
//                                         <MenuItem title="Table for influencers" icon="fas fa-table" />
//                                     </li>
//                                     <li className='my-5 has-text-white' onClick={() => setActiveSection("userRoles")}>
//                                         <MenuItem title="User Roles" icon="fas fa-users" />
//                                     </li>
//                                     <li className='my-5 has-text-white' onClick={() => setActiveSection("allCampaigns")}>
//                                         <MenuItem title="All Campaigns" icon="fas fa-clipboard-list" />
//                                     </li>
//                                     <li className='my-5 has-text-white' onClick={() => setActiveSection("applications")}>
//                                         <MenuItem title="All User and Their Applied Campaigns" icon="fas fa-clipboard-check" />
//                                     </li>
//                                     <li className='my-5 has-text-white absolute bottom-0' onClick={handleLogout}>
//                                         <MenuItem title="Logout" icon="fas fa-sign-out-alt" />
//                                     </li>

//                                 </div>
//                             </ul>
//                         </aside>
//                     </div>
//                 </div>

//                 <ul
//                     className="menu1 d-flex flex-row-reverse"
//                     onMouseEnter={handleMouseEnter}
//                     onMouseLeave={handleMouseLeave}
//                 >
//                     {!isActive && (
//                         <div className='has-text-centered'>
//                             <figure className="image is-32x32">
//                                 <img src={logo} alt="Logo" />
//                             </figure>

//                             {["createCampaign", "shortlistedInfluencers", "userRoles", "allCampaigns", "applications", "logout"].map((item) => (
//                                 <div className='my-5 has-text-white ml-4' key={item}>
//                                     <MenuItem
//                                         icon={getIconFor(item)}
//                                         clickHandler={() => {
//                                             if (item === "logout") handleLogout();
//                                             else setActiveSection(item);
//                                         }}
//                                     />
//                                 </div>
//                             ))}
//                         </div>
//                     )}
//                 </ul>
//             </nav>

//             {/* Main Content */}
//             <div className="column">
//                 <div className="columns is-ancestor">
//                     <div className="column mt-5">
//                         {activeSection === "createCampaign" && (
//                             <div className="is-child has-text-centered" style={{ height: '100vh', width: '50vw', marginLeft: '250px', }}>
//                                 <CampaignForm />
//                             </div>
//                         )}
//                         {activeSection === "shortlistedInfluencers" && (
//                             <div className='full-page-container' style={{ display: 'flex', height: '100vh', marginLeft: "150px", marginTop: "-30px" }}>
//                                 <div className='is-child' style={{ height: '150vh', width: '83vw', alignItems: 'center' }}>
//                                     <div style={{ overflowY: 'auto', flexGrow: 1 }}>
//                                         <h1>INFLUENCER TABLE</h1>
//                                         <MasterTable />
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                         {activeSection === "allCampaigns" && (
//                             <div className='subtitle' style={{ fontSize: '15px', marginLeft: "137px" }}>
//                                 <Live />
//                             </div>
//                         )}
//                         {activeSection === "userRoles" && (
//                             <div className='has-text-right' style={{ marginLeft: "150px", marginBottom: "200px", marginTop: "-35px" }}>
//                                 <div className='field'>
//                                     <div className="control my-3">
//                                         <Modal />
//                                         <UserTable />
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                         {activeSection === "applications" && (
//                             <div className='subtitle' style={{ fontSize: '15px', marginLeft: "137px" }}>
//                                 <AllUser />
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AdminDashboard;

// // Utility to get the icon based on section
// function getIconFor(section) {
//     switch (section) {
//         case "createCampaign": return "plus";
//         case "shortlistedInfluencers": return "table";
//         case "userRoles": return "users";
//         case "allCampaigns": return "clipboard-list";
//         case "applications": return "clipboard-check";
//         case "logout": return "sign-out-alt";
//         default: return "question";
//     }
// }
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import logo from "./img/Logo (1).png";
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Table from './orderPaymentAprroverTable';
import CampaignForm from "./CampaignCreateForm";
import Live from './live';
import Modal from '../pages/invite';
import UserTable from '../pages/userTable';
import MasterTable from '../pages/masterTable';
import MenuItem from './MenuItem';
import AllUser from './allCampaingsApplied';

library.add(fas);

const AdminDashboard = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const brandName = location.state ? location.state.brandName : null;

    const [isActive, setIsActive] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const activeSection = searchParams.get("section") || "allCampaigns";
    const page = searchParams.get("page") || 1; // optional, for pagination

    const handleMouseEnter = () => setIsActive(true);
    const handleMouseLeave = () => setIsActive(false);

    const handleLogout = () => {
        localStorage.removeItem("userToken");
        navigate('/signin', { replace: true });
    };

    const navigateToSection = (sectionName) => {
        setSearchParams({ section: sectionName });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [activeSection]);

    return (
        <div className="dashboard">
            <nav className="navbar" role="navigation" aria-label="main navigation">
                <div className="navbar-brand">
                    <a className="navbar-item"></a>
                </div>

                <div>
                    <span className="icon mr-3">
                        <img src="./images/hobo.jpeg" alt="Menu Icon" style={{ marginRight: "30px" }} />
                    </span>

                    <div className={`navbar-menu ${isActive ? 'is-active' : ''}`} style={{ backgroundColor: 'dark-blue' }}>
                        <aside
                            className={`menu ${isActive ? '' : 'is-hidden'} overflow-hidden`}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                        >
                            <ul className="d-flex flex-row-reverse">
                                <div className='has-text-left ml-5'>
                                    <figure className="image is-32x32">
                                        <img src={logo} alt="Logo" />
                                    </figure>

                                    <li className='my-5 has-text-white' onClick={() => navigateToSection("createCampaign")}>
                                        <MenuItem title="Create New Campaign" icon="fas fa-plus" />
                                    </li>
                                    <li className='my-5 has-text-white' onClick={() => navigateToSection("shortlistedInfluencers")}>
                                        <MenuItem title="Table for influencers" icon="fas fa-table" />
                                    </li>
                                    <li className='my-5 has-text-white' onClick={() => navigateToSection("userRoles")}>
                                        <MenuItem title="User Roles" icon="fas fa-users" />
                                    </li>
                                    <li className='my-5 has-text-white' onClick={() => navigateToSection("allCampaigns")}>
                                        <MenuItem title="All Campaigns" icon="fas fa-clipboard-list" />
                                    </li>
                                    <li className='my-5 has-text-white' onClick={() => navigateToSection("applications")}>
                                        <MenuItem title="All User and Their Applied Campaigns" icon="fas fa-clipboard-check" />
                                    </li>
                                    <li className='my-5 has-text-white absolute bottom-0' onClick={handleLogout}>
                                        <MenuItem title="Logout" icon="fas fa-sign-out-alt" />
                                    </li>
                                </div>
                            </ul>
                        </aside>
                    </div>
                </div>

                <ul
                    className="menu1 d-flex flex-row-reverse"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    {!isActive && (
                        <div className='has-text-centered'>
                            <figure className="image is-32x32">
                                <img src={logo} alt="Logo" />
                            </figure>

                            {["createCampaign", "shortlistedInfluencers", "userRoles", "allCampaigns", "applications", "logout"].map((item) => (
                                <div className='my-5 has-text-white ml-4' key={item}>
                                    <MenuItem
                                        icon={getIconFor(item)}
                                        clickHandler={() => {
                                            if (item === "logout") handleLogout();
                                            else navigateToSection(item);
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </ul>
            </nav>

            {/* Main Content */}
            <div className="column">
                <div className="columns is-ancestor">
                    <div className="column mt-5">
                        {activeSection === "createCampaign" && (
                            <div className="is-child has-text-centered" style={{ height: '100vh', width: '50vw', marginLeft: '250px' }}>
                                <CampaignForm />
                            </div>
                        )}

                        {activeSection === "shortlistedInfluencers" && (
                            <div className='full-page-container' style={{ display: 'flex', height: '100vh', marginLeft: "150px", marginTop: "-30px" }}>
                                <div className='is-child' style={{ height: '150vh', width: '83vw', alignItems: 'center' }}>
                                    <div style={{ overflowY: 'auto', flexGrow: 1 }}>
                                        <h1>INFLUENCER TABLE</h1>
                                        <MasterTable />
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeSection === "allCampaigns" && (
                            <div className='subtitle' style={{ fontSize: '15px', marginLeft: "137px" }}>
                                <Live page={page} />
                            </div>
                        )}

                        {activeSection === "userRoles" && (
                            <div className='has-text-right' style={{ marginLeft: "150px", marginBottom: "200px", marginTop: "-35px" }}>
                                <div className='field'>
                                    <div className="control my-3">
                                        <Modal />
                                        <UserTable />
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeSection === "applications" && (
                            <div className='subtitle' style={{ fontSize: '15px', marginLeft: "137px" }}>
                                <AllUser />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;

// Utility function to get icons
function getIconFor(section) {
    switch (section) {
        case "createCampaign": return "plus";
        case "shortlistedInfluencers": return "table";
        case "userRoles": return "users";
        case "allCampaigns": return "clipboard-list";
        case "applications": return "clipboard-check";
        case "logout": return "sign-out-alt";
        default: return "question";
    }
}
